<template>
	<div class="site">
		<Nav/>
        <div style="padding: 50px 0px 50px 0px;">
			<div style="max-width: 1548px;display: flex;
				margin-right: auto;
				margin-left: auto;
				position: relative;">
				<div class="most-container">
					<div style="padding: 0px 12px 0px 12px;">
						<div class="all-container">
							<div class="row" style="max-width: 1548px;">
								<div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-mn-12" v-for="item in blogList" @click="handleClick($event, item)">
									<div class="rt-item">
										<div class="rt-image">
											<img class="rt-main-image" :src="item.firstPicture">
										</div>
										<div style="padding: 25px 25px 22px;">
											<div style="padding: 25px 25px 22px;position: relative;">
												<div style="font-weight:bold;display: inline-flex;align-items: center;flex-wrap: wrap;gap: 20px;margin-bottom: 13px;">
													<div class="rt-cat-1">				
														<router-link :to="`/category/${item.category.name}`" @click.stop>
															<span class="category-style" style="background: rgba(17, 17, 17, 0.1);color: #111111;font-size: 9px;">{{ item.category.name }}</span>
														</router-link>
													</div>																													
													<div class="rtrs-rating-item">
														<div class="rating-icon off">
															<el-rate
																v-model="item.rate"
																disabled
																show-score
																text-color="#777777"
																score-template="{value} / 5">
																</el-rate>
														</div>
													</div>
												</div>
												<h3 style="cursor:pointer;font-size: 20px;line-height: 1.4;margin-bottom: 7px;margin-top: 0;">{{ item.title }}</h3>
												<ul class="entry-meta">
														<!-- <li class="post-author">by <a href="https://netsparks.online/author/admin/" title="Posts by admin" rel="author">admin</a></li> -->
													<li class="post-date">{{formatDate(item.createTime)}}</li>				
													<li><span class="post-views meta-item"><span class="meta-views meta-item very-high">Views <span class="view-number">{{ item.views }}</span> </span> </span></li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
                            
						</div>
					</div>
                    <div style="display: flex;align-items: center;justify-content: center;margin: 30px 0 5px;">
                        <el-pagination
                            :page-size="8"
                            @current-change="handleCurrentChange" 
                            :current-page="pageNum" 
                            :page-count="totalPage"
                            background
                            layout="prev, pager, next"
                            >
                        </el-pagination>
                    </div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Nav from "@/components/index/Nav";
	import Foot from "@/components/index/Foot";
	import {mapState} from "vuex";
	import {getBlogList} from "@/api/home";
	export default {
		name: "AllBlogs",
        components: {Nav,Foot},
        computed: {
			// ...mapState(['siteInfo'])
		},
		data() {
			return {
				blogList:[],
                totalPage: 0,
                pageNum: 1
			}
		},
        created(){
            this.getBlogList()
            this.pageNum = 1
        },
		methods: {
            handleClick(event, item) {
				// 判断是否点击的是 router-link 内部元素，避免触发父级 div 的点击事件
				if (event.target.closest('a')) {
					return;
				}
				this.$router.push(`/${item.title}`);
			},
            formatDate(isoString) {
				const date = new Date(isoString);
				const options = { year: 'numeric', month: 'long', day: 'numeric' };
				return date.toLocaleDateString('en-US', options);
			},
			getBlogList(pageNum) {
				getBlogList(pageNum).then(res => {
					if (res.code === 200) {
						this.blogList = res.data.list
						this.totalPage = res.data.totalPage
						console.log(this.blogList)
						// this.$nextTick(() => {
						// 	Prism.highlightAll()
						// })
						// this.getBlogListFinish = true
					} else {
						this.msgError(res.msg)
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			},
            handleCurrentChange(newPage) {
                this.pageNum = newPage
				this.getBlogList(newPage)
			},
		}
	}
</script>

<style scoped>
.rt-item {
		position: relative;
		background-color: #fff;
		border-radius: 10px;
		box-shadow: 0px 0px 35px rgb(0 0 0 / 5%);
		overflow: hidden;
		transition: all ease 0.31s;
	}
	.rt-item .rt-image {
		position: relative;
		overflow: hidden;
		cursor: pointer;
	}
	.rt-item .rt-image img {
		min-height: 380px;
		width: 100%;
		height: 100%;
		object-fit: cover;
		transform: scale(1.02);
		transition: transform 1s cubic-bezier(0.25, 0.8, 0.25, 1);
		max-width: 100%;
		border: none;
		border-radius: 0;
		box-shadow: none;
	}
	.rt-item:hover .rt-main-image {
		transform: scale(1.1);
	}
    .all-container{
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}
    .site {
		display: flex;
		min-height: 100vh;
		flex-direction: column;
	}
    .most-container{
    	width: 100%;
	}
	@media (min-width: 768px) {
		.carousel-container {
			width: 40%;
		}
		.most-container{
			width: 100%;
		}
		.header-left{
			width: 70%;
		}
		.header-right{
			width: 30%;
		}
		.header-right-margin{
			margin: 0px 0px 32px 0px;
		}
		.header-left-margin{
			margin: 0px 0px 32px 0px;
		}
		.header-right-center{
			text-align: right;
		}
		.header-left-center{
			text-align: left;
		}
		.col-md-6 {
			flex: 0 0 auto;
			padding: 0 10px 20px 10px;
			width: 50%;
		}
		.container{
			max-width: 720px;
		}
	}
    @media (max-width: 767px) {
		.header-left{
			width: 100%;
		}
		.header-right{
			width: 100%;
		}
		.header-left-margin{
			margin: 0px 0px 32px 0px;
		}
		.header-right-margin{
			margin: 0px 0px 50px 0px;
		}
		.header-right-center{
			text-align: center;
		}
		.header-left-center{
			text-align: center;
		}
		.col-mn-12 {
			flex: 0 0 auto;
			padding: 0 0 20px 0;
			width: 100%;
		}
		.row {
			margin: 10px 0 10px 0;
		}
		.col-13{
			padding: 0 5px 0 0 !important;
		}
		.container{
			max-width: 320px;
		}
		
	}
    @media (max-width: 1024px) and (min-width: 768px) {
		.blog-image {
			height: 320px;
		}
		.blog-right-image {
			height: 320px;
		}
		.row{
			margin: 15px 0 0 0;
		}
		.most-container{
			max-width: 1024px;
		}
		.col-13{
			padding: 0 5px 0 0 !important;
		}
		.col-lg-6{
			width: 100%;
		}
	}
    @media (min-width: 1200px) {
		.col-xl-3 {
			flex: 0 0 auto;
			width: 25%;
			padding: 0 10px 20px 10px;
			
		}
	}
	@media (min-width: 992px) {
		.col-lg-6 {
			flex: 0 0 auto;
			width: 50%;
		}
		.col-lg-3 {
			flex: 0 0 auto;
			width: 25%;
			padding: 0 10px 20px 10px;
		}
		.container{
			max-width: 960px;
		}
	}
    ::v-deep .off .el-rate__item{
		display: none !important;
	}
    .row {
		display: flex;
		flex-wrap: wrap;
	}
    ul.entry-meta {
		list-style: none;
		margin-bottom: 0;
		margin-top: 5px;
		margin-left: 0;
		padding-left: 0;
	}
	ul.entry-meta li {
		display: inline-block;
		color: #777777;
		font-size: 14px;
		font-weight: bold;
		letter-spacing: 0.2px;
		line-height: 1.2;
		margin-right: 10px;
		text-transform: capitalize;
		transition: all ease 0.31s;
	}
    .category-style {
		display: inline-flex;
		font-size: 14px;
		color: #fff;
		border-radius: 4px;
		padding: 8px 15px 8px;
		font-weight: 500;
		letter-spacing: 0.7px;
		line-height: 1;
		transition: all 0.3s ease-in-out;
	}
</style>